import { useSessionValue } from './useSession';

export const useIsLoggedInValue = () => {
  const session = useSessionValue();
  return Boolean(session?.customer);
};
